
import { useContext, useEffect } from "react";
import AuthenticationContext, {
  AuthenticationState,
} from "../contexts/auth/AuthenticationContext";
import "./StartLayout.css";
import { Outlet, useNavigate } from "react-router-dom";
import LoadingCurtain from "../components/@shared/LoadingCurtain";
import { OVERVIEW_PAGE_PATH } from "../pages/OverviewPage";

interface StartLayoutProps {}

const StartLayout: React.FC<StartLayoutProps> = (_) => {
  const authContext = useContext(AuthenticationContext);
  const navigate = useNavigate();

  useEffect(() => {
    if (authContext.authenticationState === AuthenticationState.AUTHENTICATED) {
      // Honor a ?redirect= internal path (e.g. the OAuth consent page) so the
      // user returns where they came from after logging in. Only same-origin
      // relative paths are followed (anti open-redirect).
      const redirect = new URLSearchParams(window.location.search).get('redirect');
      if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
        navigate(redirect);
      } else {
        navigate(OVERVIEW_PAGE_PATH);
      }
    }
  }, [authContext.authenticationState, navigate]);

  return authContext.authenticationState !==
    AuthenticationState.UNAUTHENTICATED ? (
    <LoadingCurtain />
  ) : (
    <div className="start-layout">
      <Outlet />
    </div>
  );
};

export default StartLayout;
